export default "<ng-template></ng-template>";